//#region src/generated/schemas.gen.ts
var e = {
	type: "string",
	enum: /* @__PURE__ */ "ORDER_MANAGEMENT.LEGACY_ORDER_MANAGEMENT.AUTO_ORDER_IMPORT.BOL_DOT_COM_VVB_SHIPMENTS.CUSTOM_CONTRACTS.DIRECT_PRINTING.DISABLE_LABEL_HEADLINE.EXTENDED_SHIPPING_RULES.NESTED_SHIPMENT_LABEL_ON_PACKING_SLIP.ORDER_INVOICE.ORDER_NOTES.ORDER_PICKLIST.RETURN_LINK_ON_PACKING_SLIP.SAVE_ORDER_SORTING_SETTING.SCAN_MODE.SHIPMENT_BULK_CREATE_FROM_ADDRESS_BOOK.SHIPMENT_BULK_EDITS.SHIPMENT_DISCOUNT.SHOP_LOGO_ON_PACKING_SLIP.TIER1_ANALYTICS.TIER2_ANALYTICS.TIER3_ANALYTICS.TIER4_ANALYTICS.TRACK_TRACE_EMAIL_SECONDARY_RECIPIENTS.UNLIMITED_SHIPMENTS_PER_ORDER_LINE.UNLIMITED_SHIPPING_RULES".split("."),
	description: "A feature that is available in the platform."
}, t = {
	type: "string",
	enum: ["VASCO"],
	description: "The fulfilment platform used."
}, n = {
	type: "string",
	enum: [
		"MYPARCEL_BE",
		"MYPARCEL_NL",
		"MYPARCEL_IT"
	],
	description: "The operating platform identifier."
}, r = {
	type: "string",
	pattern: "^shop\\/.{1,250}$",
	description: "A shop principal identifier."
}, i = {
	type: "string",
	pattern: "^user\\/.{1,250}$",
	description: "A user principal identifier."
}, a = {
	anyOf: [{ $ref: "#/components/schemas/PrincipalTypeShop" }, { $ref: "#/components/schemas/PrincipalTypeUser" }],
	description: "A shop principal identifier."
}, o = {
	type: "string",
	enum: ["SHOP_DEFAULT"],
	description: "The specific role assigned to a shop."
}, s = {
	type: "string",
	enum: [
		"ADMIN_CS",
		"ADMIN_CS_ADVANCED",
		"ADMIN_FINANCE",
		"ADMIN_IT_SUPPORT",
		"ADMIN_SALES",
		"ADMIN_SUPER",
		"CUSTOMER_ADMIN",
		"CUSTOMER_FINANCIAL",
		"CUSTOMER_FUNCTIONAL_MANAGER",
		"CUSTOMER_MAIN",
		"CUSTOMER_MARKETING",
		"CUSTOMER_SERVICE",
		"CUSTOMER_SUB",
		"CUSTOMER_WAREHOUSE"
	],
	description: "The specific role assigned to a user."
}, c = {
	type: "object",
	properties: {
		accountId: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the account."
		},
		platform: { $ref: "#/components/schemas/Platform" },
		features: {
			type: "array",
			items: { $ref: "#/components/schemas/Feature" },
			minItems: 1,
			maxItems: 26
		},
		fulfilmentPlatforms: {
			type: "array",
			items: { $ref: "#/components/schemas/FulfilmentPlatform" },
			minItems: 1,
			maxItems: 1
		},
		impersonator: { $ref: "#/components/schemas/PrincipalType" }
	},
	required: ["accountId", "platform"]
}, l = { allOf: [{ $ref: "#/components/schemas/PrincipalCommon" }, {
	type: "object",
	properties: {
		id: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the shop."
		},
		type: {
			type: "string",
			enum: ["SHOP"],
			description: "The principal type."
		},
		role: { $ref: "#/components/schemas/RoleShop" },
		shopIds: {
			type: "array",
			items: {
				type: "string",
				minLength: 1,
				maxLength: 50,
				description: "The unique identifier of the shop."
			},
			minItems: 1,
			maxItems: 1
		}
	},
	required: [
		"id",
		"type",
		"role",
		"shopIds"
	]
}] }, u = { allOf: [{ $ref: "#/components/schemas/PrincipalCommon" }, {
	type: "object",
	properties: {
		id: {
			type: "string",
			minLength: 1,
			maxLength: 50,
			description: "The unique identifier of the user."
		},
		type: {
			type: "string",
			enum: ["USER"],
			description: "The principal type."
		},
		role: { $ref: "#/components/schemas/RoleUser" },
		shopIds: {
			type: "array",
			items: {
				type: "string",
				minLength: 1,
				maxLength: 50,
				description: "The unique identifier of the shop."
			},
			minItems: 1,
			maxItems: 500
		}
	},
	required: [
		"id",
		"type",
		"role",
		"shopIds"
	]
}] }, d = {
	oneOf: [{ $ref: "#/components/schemas/PrincipalShop" }, { $ref: "#/components/schemas/PrincipalUser" }],
	discriminator: {
		propertyName: "type",
		mapping: {
			SHOP: "#/components/schemas/PrincipalShop",
			USER: "#/components/schemas/PrincipalUser"
		}
	}
}, f = {
	ORDER_MANAGEMENT: "ORDER_MANAGEMENT",
	LEGACY_ORDER_MANAGEMENT: "LEGACY_ORDER_MANAGEMENT",
	AUTO_ORDER_IMPORT: "AUTO_ORDER_IMPORT",
	BOL_DOT_COM_VVB_SHIPMENTS: "BOL_DOT_COM_VVB_SHIPMENTS",
	CUSTOM_CONTRACTS: "CUSTOM_CONTRACTS",
	DIRECT_PRINTING: "DIRECT_PRINTING",
	DISABLE_LABEL_HEADLINE: "DISABLE_LABEL_HEADLINE",
	EXTENDED_SHIPPING_RULES: "EXTENDED_SHIPPING_RULES",
	NESTED_SHIPMENT_LABEL_ON_PACKING_SLIP: "NESTED_SHIPMENT_LABEL_ON_PACKING_SLIP",
	ORDER_INVOICE: "ORDER_INVOICE",
	ORDER_NOTES: "ORDER_NOTES",
	ORDER_PICKLIST: "ORDER_PICKLIST",
	RETURN_LINK_ON_PACKING_SLIP: "RETURN_LINK_ON_PACKING_SLIP",
	SAVE_ORDER_SORTING_SETTING: "SAVE_ORDER_SORTING_SETTING",
	SCAN_MODE: "SCAN_MODE",
	SHIPMENT_BULK_CREATE_FROM_ADDRESS_BOOK: "SHIPMENT_BULK_CREATE_FROM_ADDRESS_BOOK",
	SHIPMENT_BULK_EDITS: "SHIPMENT_BULK_EDITS",
	SHIPMENT_DISCOUNT: "SHIPMENT_DISCOUNT",
	SHOP_LOGO_ON_PACKING_SLIP: "SHOP_LOGO_ON_PACKING_SLIP",
	TIER1_ANALYTICS: "TIER1_ANALYTICS",
	TIER2_ANALYTICS: "TIER2_ANALYTICS",
	TIER3_ANALYTICS: "TIER3_ANALYTICS",
	TIER4_ANALYTICS: "TIER4_ANALYTICS",
	TRACK_TRACE_EMAIL_SECONDARY_RECIPIENTS: "TRACK_TRACE_EMAIL_SECONDARY_RECIPIENTS",
	UNLIMITED_SHIPMENTS_PER_ORDER_LINE: "UNLIMITED_SHIPMENTS_PER_ORDER_LINE",
	UNLIMITED_SHIPPING_RULES: "UNLIMITED_SHIPPING_RULES"
}, p = { VASCO: "VASCO" }, m = {
	MYPARCEL_BE: "MYPARCEL_BE",
	MYPARCEL_NL: "MYPARCEL_NL",
	MYPARCEL_IT: "MYPARCEL_IT"
}, h = { SHOP_DEFAULT: "SHOP_DEFAULT" }, g = {
	ADMIN_CS: "ADMIN_CS",
	ADMIN_CS_ADVANCED: "ADMIN_CS_ADVANCED",
	ADMIN_FINANCE: "ADMIN_FINANCE",
	ADMIN_IT_SUPPORT: "ADMIN_IT_SUPPORT",
	ADMIN_SALES: "ADMIN_SALES",
	ADMIN_SUPER: "ADMIN_SUPER",
	CUSTOMER_ADMIN: "CUSTOMER_ADMIN",
	CUSTOMER_FINANCIAL: "CUSTOMER_FINANCIAL",
	CUSTOMER_FUNCTIONAL_MANAGER: "CUSTOMER_FUNCTIONAL_MANAGER",
	CUSTOMER_MAIN: "CUSTOMER_MAIN",
	CUSTOMER_MARKETING: "CUSTOMER_MARKETING",
	CUSTOMER_SERVICE: "CUSTOMER_SERVICE",
	CUSTOMER_SUB: "CUSTOMER_SUB",
	CUSTOMER_WAREHOUSE: "CUSTOMER_WAREHOUSE"
};
//#endregion
export { s as _, g as a, n as c, l as d, a as f, o as g, u as h, h as i, c as l, i as m, p as n, e as o, r as p, m as r, t as s, f as t, d as u };
